import { createI18n } from 'vue-i18n'
import de from '@/locales/de.json'

/**
 * The one i18n instance, exported so code outside a component can translate.
 *
 * Stores carry user-facing text too - the dock's failure messages are the
 * clearest case - and they had been hardcoding German in the store because
 * there was nothing to reach for. `i18n.global.t(...)` is that something.
 */
export const i18n = createI18n({
  fallbackLocale: 'de',
  legacy: false,
  locale: 'de',
  messages: { de },
})

/** Translate from outside a component. */
export const t = i18n.global.t
